module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/1@2.png?fb35345e408a3a8d5bed842d16131c6f";